import { createContext } from '@berlin-front/common/composables/context';
import type { ContextValueType } from '@berlin-front/common/composables/context';
import { windowOpenNewTab } from '@berlin-front/common/utils';
import { broadcast } from '@/broadcast';

export const useOfficialIdentificationFail = () => {
  const cancelClick = () => {
    broadcast.send({
      type: 'MODAL_CONTROL_FAILED',
      payload: {},
    });
  };
  const openAppClick = () => {
    const path = process.env.VUE_APP_APPLINK_URL ?? '';
    windowOpenNewTab(path);
    cancelClick();
  };

  return {
    // 関数
    openAppClick,
    cancelClick,
  };
};

export const OfficialIdentificationFailContext = createContext({ useOfficialIdentificationFail });
export type OfficialIdentificationFailContextType = ContextValueType<typeof OfficialIdentificationFailContext>;
